export default {
    DARK: "dark",
    LIGHT: "light"
}